// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import AdvancedCarousel from "./AdvancedCarousel";
import PhotoSwipe from "./PhotoSwipe";

export default class CarouselGallery extends WebComponent {
  constructor(props) {
    super(props);

    this.componentOne = null;
    this.componentTwo = null;
  }

  didMount() {
    this.componentOne = new AdvancedCarousel(this.props);
    this.componentTwo = new PhotoSwipe(this.props);

    this.componentOne.decorate(this.element);
    this.componentTwo.decorate(this.element);
  }

  willUnMount() {
    this.componentOne.dispose();
    this.componentTwo.dispose();
  }
}



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/CarouselGallery.js